<script>
  import { createEventDispatcher, getContext, onDestroy } from 'svelte'
  import { faCaretDown, faCaretUp } from '@fortawesome/pro-solid-svg-icons'
  import Icon from '../Icon/'
  import filterClasses, { cssPrefix } from '../helper-classes.js'

  import { getId } from '../FormElements/builder.js'
  export let id = getId()

  const dispatch = createEventDispatcher()

  export let index = null
  export let type = ''

  export let header = ''
  export let activeHeader = false
  export let clickableHeader = false
  export let headerIcon = ''
  export let narrow = false
  export let wrapped = false
  export let width = null
  export let maxWidth = null
  export let hasExpansion = false
  export let isExpanded = false
  export let sortable = null
  export let sorted = ''
  export let align = null
  export let valign = null
  let contentStyle

  export let style = null
  export let helperClass = null
  let importedClasses = ''
  let importedHeaderClasses = ''
  export { importedClasses as class }
  export { importedHeaderClasses as headerClass }
  export let classPermissiveMode = false
  if (helperClass) {
    console.debug("[DS:deprecation] please replace 'helperClass' prop by 'class'")
    if (!importedClasses) {
      importedClasses = helperClass
    }
  }
  const classes = []
  if (importedClasses) classes.push(...filterClasses(importedClasses, classPermissiveMode))
  if (align) classes.push(`is-align-${align}`)
  if (valign) classes.push(`is-valign-${valign}`)

  const headerClasses = [`${cssPrefix}table-column`]
  if (header === '') headerClasses.push('is-empty')
  if (clickableHeader) classes.push('is-clickable')
  if (importedHeaderClasses) headerClasses.push(...filterClasses(importedHeaderClasses, classPermissiveMode))

  if (index == null) console.debug(`[DS:DataCell] invalid index prop ${index}`)

  const cellsCounter = getContext('dataTableCellsCounter')
  if (index === 0) {
    cellsCounter.increment()
  }

  if (!['', 'number', 'date', 'image'].includes(type)) {
    console.debug(`[DS:DataCell] invalid type ${type}`)
  } else if (type) {
    classes.push('is-' + type)
    headerClasses.push('is-' + type)
  }

  if (narrow) {
    classes.push('is-narrow')
    headerClasses.push('is-narrow')
  }

  if (wrapped) {
    classes.push('is-wrapped')
    headerClasses.push('is-wrapped')
  }

  if (hasExpansion) {
    classes.push('has-expansion')
  }

  if (isExpanded) {
    classes.push('is-expanded')
  }

  if (width || maxWidth) {
    classes.push('is-clipped')

    if (width) {
      contentStyle = `width: ${width}px;`
    }

    if (maxWidth) {
      contentStyle ? (contentStyle += `max-width: ${maxWidth}px;`) : (contentStyle = `max-width: ${maxWidth}px;`)
    }
  }
  const onClickHeader = () => dispatch('clickHeader')

  onDestroy(() => {
    if (index === 0) cellsCounter.decrement()
  })
</script>

{#if index}
  <td class={classes.join(' ')} data-header={header} {style} {id}>
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <span
      class="gl-table-cell-content"
      style={contentStyle}
      on:click={e => e.stopPropagation()}
      role="button"
      tabindex="0"><slot /></span
    >
  </td>
{:else if clickableHeader}
  <th {id} aria-sort={sorted === 'up' ? 'ascending' : sorted === 'down' ? 'descending' : ''}>
    {#if headerIcon}
      <button on:click|preventDefault={onClickHeader} class:is-active={activeHeader} class={headerClasses.join(' ')}>
        <span class="gl-table-head-label">{header}</span>
        {#if typeof headerIcon === 'string'}
          <Icon name={headerIcon} />
        {:else}
          <Icon icon={headerIcon} />
        {/if}
      </button>
    {:else if sortable}
      <button
        on:click|preventDefault={onClickHeader}
        class:is-sorted={sorted === 'up' || sorted === 'down'}
        class={headerClasses.join(' ')}
      >
        <span class="gl-table-head-label">{header}</span>

        <span
          class="gl-table-head-carets"
          class:is-up={sorted === 'up'}
          class:is-down={sorted === 'down'}
          aria-label={`Sort by ${header}`}
          aria-hidden="true"
        >
          <Icon icon={faCaretUp} />
          <Icon icon={faCaretDown} />
        </span>
      </button>
    {:else}
      <button on:click|preventDefault={onClickHeader} class:is-active={activeHeader} class={headerClasses.join(' ')}>
        <span class="gl-table-head-label">{header}</span>
      </button>
    {/if}
  </th>
{:else}
  <th {id}>
    <div class:is-active={activeHeader} class={headerClasses.join(' ')}>
      {header}
      {#if headerIcon}
        {#if typeof headerIcon === 'string'}
          <Icon name={headerIcon} />
        {:else}
          <Icon icon={headerIcon} />
        {/if}
      {/if}
    </div>
  </th>
{/if}
